import { Injectable } from '@angular/core';
import { KeepAliveService } from '../../keep-alive.service';

@Injectable({
  providedIn: 'root',
})
export class ServerTimeService {
  private serverTimeOffset: number;

  constructor(private keepAliveService: KeepAliveService) {}

  public updateServerTimeOffset(): Promise<void> {
    return new Promise((resolve) => {
      this.keepAliveService.fetchServerTime().subscribe((serverTime) => {
        this.serverTimeOffset = this.systemNow() - serverTime;
        resolve();
      });
    });
  }

  public offsetNow(): number {
    return this.systemNow() - this.serverTimeOffset;
  }

  private systemNow(): number {
    return Date.now();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/services/server-time/server-time.service.ts